import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory, Redirect } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import {
  Card as CardTable,
  Container as ContainerBody,
  Row,
  Col
} from 'react-bootstrap';

import {
  ButtonDivision,
  Card,
  CardHeader,
  CardHeaderTotal,
  CenterHeaderQuantity,
  CenterItemQuantity,
  CloseIconStyled,
  Container,
  ContainerCard,
  DesktopDetails,
  DesktopGridDetails,
  FlexContainer,
  IconInformationBlue,
  LeftItemQuantity,
  LeftItemQuantityTotal,
  LoadingIcon,
  MainContainer,
  PrintIconStyled,
  Product,
  RightItemQuantity,
  RightItemQuantityTotal,
  Title,
  TitleCard,
  TitlePage,
  TypeOrderContainer
} from './styles';
import '~/components/styles/Global.css';
import Loading from '~/components/layout/Loading';
import IconProduct from '~/components/layout/IconProduct';
import TimelineStepsLogistic from '~/components/pages/Logistic/TimelineStepsLogistic';
import OpenChatBot from '~/components/layout/Chatbot';
import close from '~/assets/images/close.png';
import back from '~/assets/images/back.svg';
import PrinterIcon from '~/assets/images/printer.svg';
import informationBlue from '~/assets/images/information-blue.svg';
import api from '~/services/api';

import { InfoButton } from '~/components/layout/Buttons';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { handleStatusTextLogistic } from '~/utils/functions/mapperStatusOrderLogistic';
import { Details, Division, Text } from '~/components/pages/Order/Summary/styles';

export default function StatusOrder() {
  const history = useHistory();
  const dispatch = useDispatch();
  const componentRef = useRef();
  const orders = useSelector(state => state.statusReducer.orders);
  const [loadingPage, setLoadingPage] = useState(true);
  const [isLoading, setIsloading] = useState(true);
  const [canceled, setCanceled] = useState(false);
  const [orderDetails, setOrderDetails] = useState();
  const [showButton, setShowButton] = useState(true);
  const [router, setRouter] = useState('');
  const [message, setMessage] = useState('');
  const [stepsInfo, setStepsInfo] = useState({
    date: "",
    description: ""
  });

  const isMobile = window.screen.width < 771;
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let id = params.get('id');

  const roles = useSelector(state => state.rolesReducer.roles);

  function isStatusCanceled(status) {
    return status === "CANCELADO" || status === "NÃO LIBERADO PELO FINANCEIRO";
  }

  function firstLetterUppercase(str){
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  let selectedOrder = null;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  async function getOrderDetails() {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token")
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    try {
      const res = await api.get(`/sales/order/v2/orders-ga/${id}`, parameters);
      dispatch({
        type: 'SET_ORDER_PAYMENT',
        order: res.data
      });

      setOrderDetails(res.data);
      setIsloading(false)
    } catch (error) {
      toast.error('Não foi possível consultar o status do seu pedido. Por favor, tente novamente ou acione o SAP Local');
      setIsloading(false)
      history.push('/portal')
    }
    setLoadingPage(false);
  }

  function formatCurrency(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }


  function handleSteps(orderStatus, occupationCycleStatus) {

    const removeAccents = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalizedOrderStatus = removeAccents(orderStatus).toUpperCase();
    const normalizedOccupationCycleStatus = occupationCycleStatus ? removeAccents(occupationCycleStatus).toUpperCase() : '';

    switch (normalizedOrderStatus) {
      case 'CANCELADO':
      case 'AGUARDANDO ANALISE DO FINANCEIRO':
      case 'AGUARDANDO APROVACAO DA LOGISTICA PARA INCLUSAO NA PROGRAMACAO':
      case 'AGUARDANDO APROVACAO DO CONSULTOR COMERCIAL PARA INCLUSAO NA PROGRAMACAO':
      case 'RASCUNHO':
      case 'EM VALIDACAO':
      case 'EM ANALISE PELO FINANCEIRO':
        return 'Pedido';
      case 'AGUARDANDO GERAR CHAVE PIX':
      case 'AGUARDANDO PAGAMENTO':
      case 'PENDENTE DE PAGAMENTO DE DIVIDAS ANTERIORES':
      case 'VALIDAR COMPROVANTE':
      case 'PENDENTE GERAR OU APROVAR PROTOCOLO':
      case 'PENDENTE CHECAR CREDITO':
      case 'NAO LIBERADO PELO FINANCEIRO':
        return 'Financeiro';
      case 'LIBERADO':
        if (normalizedOccupationCycleStatus && normalizedOccupationCycleStatus === 'NOTA FISCAL LIBERADA') return 'Liberação';
        if (normalizedOccupationCycleStatus && normalizedOccupationCycleStatus === 'SAIDA DO VEICULO REALIZADA') return 'Saída';
        return 'Faturamento';
      default:
        return '';
    }
  }


  function formatCreditNoteDescription(productName) {
    const descriptions = {
      AV_CR_DCTO_CM_HUB_BA: isMobile ? 'Desc. comercial HUB'    : 'Desconto comercial HUB',
      AV_CR_DESC_AVULSO:    isMobile ? 'Desc. avulso'           : 'Desconto avulso',
      AV_CR_DES_ADTOPIXBA:  isMobile ? 'Desc. adiantamento PIX' : 'Desconto adiantamento PIX',
      AV_CR_DES_ADTOPIXUG:  isMobile ? 'Desc. adiantamento PIX' : 'Desconto adiantamento PIX',
      AV_CR_DSCTO_COM_HUB:  isMobile ? 'Desc. comercial HUB'    : 'Desconto comercial HUB',
      AV_CR_DST_LAPIDARBA:  isMobile ? 'Desc. Lapidar'          : 'Desconto Lapidar',
      AV_CR_DST_LAPIDARUG:  isMobile ? 'Desc. Lapidar'          : 'Desconto Lapidar'
    };
    return descriptions[productName] || 'Descrição não encontrada';
  };

  const discountTotals = {};

  orderDetails && orderDetails.creditNotesDiscount.forEach((discount) => {
    const discounts = formatCreditNoteDescription(discount.type);
    if (discountTotals.hasOwnProperty(discounts)) {
      discountTotals[discounts] += discount.value;
    } else {
      discountTotals[discounts] = discount.value;
    }
  });

  function getTotalCoast() {
    const totalCost = orderDetails.products.reduce((total, product) => {
      return total + product.unitPrice * product.quantity;
    }, 0);
    return totalCost;
  }

  function getTotalSubsidizedApplied() {
    const totalSubsidizedApplied = orderDetails.products.reduce((total, product) => {
      return total + (product.sponsoredQuantity) * product.unitPrice;
    }, 0);
    return totalSubsidizedApplied;
  }

  function getTotalReplacementApplied() {
    const totalReplacementsApplied = orderDetails.products.reduce((total, product) => {
      return total + (product.voucherQuantity + product.shiftQuantity) * product.unitPrice;
    }, 0);
    return totalReplacementsApplied;
  }

  function getTotalDiscount() {

    if (orderDetails && orderDetails.creditNotesDiscount.length === 0) {
      const totalDiscount = orderDetails && orderDetails.shippingTaxDiscount +  orderDetails.reweighingDiscountValue;
      return totalDiscount
    }

    const totalDiscount = orderDetails && orderDetails.creditNotesDiscount.reduce((total, product) => {
      return total + product.value ;
    }, 0);

    return totalDiscount - (orderDetails.shippingTaxDiscount +  orderDetails.reweighingDiscountValue)
  }

  function getTotal() {
    if(getTotalDiscount() > 0 ) {
      const total = (getTotalCoast() - getTotalReplacementApplied() - getTotalDiscount());
      return total;
    } else {
      const total = getTotalCoast() - (getTotalReplacementApplied() - getTotalDiscount());
      return total;
    }
  }


  useEffect(() => {
    getOrderDetails();
  }, []);

  useEffect(() => {
    dispatch({ type: 'ORDER_EDIT_DONE' });
    dispatch({ type: 'LOADING_CANCEL', loadingCancel: true });
    dispatch({ type: 'CANCELED_ORDER', cancelOrder: false });
    const search = window.location.search;
    const id = search.slice(4, 50);

    orders.map(order => {
      if (id === order.id) return selectedOrder = order;
    });

    const statusText = handleStatusTextLogistic(orderDetails && orderDetails?.orderStatus ? orderDetails && orderDetails?.orderStatus : '', orderDetails && orderDetails?.occupationCycleStatus);

    setStepsInfo({
      dateBegin: selectedOrder && selectedOrder?.creationDate,
      dateEnd: selectedOrder && selectedOrder?.shipping?.departureDate,
      description: firstLetterUppercase(statusText)
    });

    setCanceled(
      isStatusCanceled(
        orderDetails && orderDetails?.orderStatus,
        orderDetails && orderDetails?.occupationStatus
      )
    );


  }, [orderDetails]);

  useEffect(() => {
    let newShowButton = true;
    let newRouter = '';
    let newMessage = '';

    const removeAccents = str => str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    const statusWithoutAccents = removeAccents(orderDetails && orderDetails?.orderStatus.toLowerCase());

    switch (statusWithoutAccents) {
      case "aguardando gerar chave pix":
      case "aguardando pagamento":
        newRouter = '/pagamento-via-pix';
        newMessage = "Confirmar Pagamento";
        break;
      case "pendente de pagamento de dividas anteriores":
        newRouter = '/pagar-debito-anterior';
        newMessage = "Consultar valores em aberto";
        break;
      default:
        newShowButton = false;
        break;
    }

    setShowButton(newShowButton);
    setRouter(newRouter);
    setMessage(newMessage);
  }, [orderDetails && orderDetails?.orderStatus]);

  return (
    <Container>
      {verifyRoles(roles, 'STATUS_DO_PEDIDO') ? (
        <>
          <TitlePage>
            <CloseIconStyled
              src={back}
              alt="Ícone de voltar"
              onClick={() => history.push('/lista-de-pedidos')}
            />
            <CloseIconStyled
              src={close}
              alt="Ícone de fechar"
              onClick={() => history.push('/lista-de-pedidos')}
            />
          </TitlePage>
          {loadingPage ? (
            <Loading loadingColor={'white'} />
          ) : (
            <Card ref={componentRef}>
              {isLoading ? (
                <Loading margin={"100px 100px 100px 45%"} />
              ) : (
                <>
                <DesktopDetails>
                  <TitleCard>Status do Pedido: {orderDetails && orderDetails?.number}</TitleCard>
                  <PrintIconStyled
                    src={PrinterIcon}
                    alt="Ícone de voltar"
                    onClick={handlePrint}
                  />
                </DesktopDetails>
              <TimelineStepsLogistic
                colortemp="#A440E3"
                stepsInfo={stepsInfo}
                title={handleSteps(orderDetails && orderDetails?.orderStatus, orderDetails && orderDetails?.occupationCycleStatus)}
                canceled={canceled}
              />
              <Details>
                <TitleCard>Detalhes</TitleCard>
                <DesktopGridDetails>
                  <FlexContainer>
                    <TypeOrderContainer>
                      <Text style={{width: isMobile ? 190: 140}}>
                        <strong>Tipo de Pedido</strong>
                        <p>
                          {orderDetails.serviceType === 'ENTREGA'
                            ? 'Entrega'
                            : 'Retira'}
                        </p>
                      </Text>
                      {orderDetails.serviceType === 'RETIRA' &&
                        <Details
                          style={{cursor: 'pointer'}}
                          onClick={()=> history.push('/condicao-carregamento')}
                        >
                          <img src={informationBlue} style={IconInformationBlue} />
                        </Details>
                      }
                    </TypeOrderContainer>
                    <Text>
                      <strong>Origem</strong>
                      <p>{orderDetails.origin}</p>
                    </Text>
                  </FlexContainer>
                  <div>
                    <Text>
                      <strong>Data do Carregamento</strong>
                      <p>
                        {moment(
                          orderDetails.requireDate,
                          'YYYY-MM-DD',
                        ).format('DD/MM/YYYY')}
                      </p>
                    </Text>
                    <Text>
                      <strong>Filial</strong>
                      <p>{orderDetails.supplyBranch}</p>
                    </Text>
                  </div>
                </DesktopGridDetails>
              </Details>
              <Division key={1}>
              </Division>
              <div>
                <MainContainer>
                  <Title>
                    <span>Resumo do Pedido</span>
                  </Title>
                  <ContainerCard>
                    <CardTable.Header style={CardHeader}>
                      <ContainerBody>
                        <Row>
                          <Col xs={4}>
                            <Product>
                              <LeftItemQuantity>Item</LeftItemQuantity>
                            </Product>
                          </Col>
                          <Col xs={4}>
                            <CenterItemQuantity>Quantidade</CenterItemQuantity>
                          </Col>
                          <Col xs={4}>
                            <RightItemQuantity>{formatCurrency(getTotalCoast())}</RightItemQuantity>
                          </Col>
                        </Row>
                      </ContainerBody>
                    </CardTable.Header>

                    {orderDetails.products.map((products, index) => (
                      <Row key={index}style={{ padding: '0.5rem 2rem' }}>
                        <Col xs={4}>
                          <Product>
                            <IconProduct
                              productName="p13"
                              styles={{
                                p2: { margin: "0 .5rem .2rem 0", width: "15%" },
                                p5: { margin: "0 .5rem .2rem 0", width: "15%" },
                                p20: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p45: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p90: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p13: { margin: "0 .5rem .2rem 0", width: "15%" }
                              }}
                            />
                            <LeftItemQuantity>{products.name}</LeftItemQuantity>
                          </Product>
                        </Col>
                        <Col xs={4}>
                          <CenterHeaderQuantity>{products.quantity}</CenterHeaderQuantity>
                        </Col>
                        <Col xs={4}>
                          <RightItemQuantity>{formatCurrency(products.quantity * products.unitPrice)}</RightItemQuantity>
                        </Col>
                      </Row>
                    ))}

                  </ContainerCard>

                  <ContainerCard style={{ marginTop: '2rem' }}>
                    {getTotalSubsidizedApplied() > 0 && (
                       <div>
                          <CardTable.Header style={CardHeader}>
                            <ContainerBody>
                              <Row>
                                <Col xs={4}>
                                  <Product>
                                    <LeftItemQuantity>Vasilhames Subsidiados</LeftItemQuantity>
                                  </Product>
                                </Col>
                                <Col xs={4}>
                                  <CenterItemQuantity>Quantidade</CenterItemQuantity>
                                </Col>
                                <Col xs={4}>
                                  <RightItemQuantity>{formatCurrency(getTotalCoast())}</RightItemQuantity>
                                </Col>
                              </Row>
                            </ContainerBody>
                          </CardTable.Header>

                          {orderDetails.products.map((products) => (
                            products.sponsoredQuantity > 0 && (
                            <Row style={{ padding: '0.5rem 2rem' }}>
                              <Col xs={4}>
                                <Product>
                                  <IconProduct
                                    productName="p13"
                                    styles={{
                                      p2: { margin: '0 .5rem .2rem 0', width: '15%' },
                                      p5: { margin: '0 .5rem .2rem 0', width: '15%' },
                                      p20: { margin: '0 .5rem .2rem 0', width: '10%' },
                                      p45: { margin: '0 .5rem .2rem 0', width: '10%' },
                                      p90: { margin: '0 .5rem .2rem 0', width: '10%' },
                                      p13: { margin: '0 .5rem .2rem 0', width: '15%' },
                                    }}
                                  />
                                    <LeftItemQuantity>{products.name}</LeftItemQuantity>
                                </Product>
                              </Col>
                              <Col xs={4}>
                                <CenterHeaderQuantity>{products.sponsoredQuantity}</CenterHeaderQuantity>
                              </Col>
                              <Col xs={4}>
                                <RightItemQuantity>---</RightItemQuantity>
                              </Col>
                            </Row>
                          )
                        ))}
                       </div>
                    )}
                  </ContainerCard>
                  <ContainerCard style={{ marginTop: '2rem' }}>
                  {orderDetails.products.map((products, index) => (
                  (products.shiftQuantity > 0 || products.voucherQuantity > 0) && (
                    <>
                      <CardTable.Header style={CardHeader}>
                        <ContainerBody>
                          <Row>
                            <Col xs={4}>
                              <Product>
                                <LeftItemQuantity>Reposições Aplicadas</LeftItemQuantity>
                              </Product>
                            </Col>
                            <Col xs={4}>
                              <CenterItemQuantity>Quantidade</CenterItemQuantity>
                            </Col>
                            <Col xs={4}>
                              <RightItemQuantity>- {formatCurrency(getTotalReplacementApplied())}</RightItemQuantity>
                            </Col>
                          </Row>
                        </ContainerBody>
                      </CardTable.Header>
                      <Row key={index} style={{ padding: '0.5rem 2rem' }}>
                        <Col xs={4}>
                          <Product>
                            <IconProduct
                              productName="p13"
                              styles={{
                                p2: { margin: "0 .5rem .2rem 0", width: "15%" },
                                p5: { margin: "0 .5rem .2rem 0", width: "15%" },
                                p20: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p45: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p90: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p13: { margin: "0 .5rem .2rem 0", width: "15%" }
                              }}
                            />
                            <LeftItemQuantity>{products.name}</LeftItemQuantity>
                          </Product>
                        </Col>
                        <Col xs={4}>
                          <CenterHeaderQuantity>{products.voucherQuantity + products.shiftQuantity}</CenterHeaderQuantity>
                        </Col>
                        <Col xs={4}>
                          <RightItemQuantity>---</RightItemQuantity>
                        </Col>
                      </Row>
                    </>
                  )
                  ))}
                  </ContainerCard>
                  <ContainerCard style={{ marginTop: '2rem' }}>
                    {getTotalDiscount() !== 0 && (
                      <div>
                        <CardTable.Header style={CardHeader}>
                          <ContainerBody>
                            <Row>
                              <Col xs={4}>
                                <Product>
                                  <LeftItemQuantity>Descontos</LeftItemQuantity>
                                </Product>
                              </Col>
                              <Col xs={4}>
                                <CenterHeaderQuantity>&nbsp;</CenterHeaderQuantity>
                              </Col>
                              <Col xs={4}>
                                {getTotalDiscount() > 0 ? (
                                  <RightItemQuantity>- {formatCurrency(getTotalDiscount())}</RightItemQuantity>
                                ) : (
                                    <RightItemQuantity>{formatCurrency(getTotalDiscount())}</RightItemQuantity>
                                )}
                              </Col>
                            </Row>
                          </ContainerBody>
                        </CardTable.Header>
                        {Object.entries(discountTotals).map(([type, value], index) => (
                          <Row key={index} style={{ padding: '0.5rem 2rem' }}>
                            <Col xs={4}>
                              <LeftItemQuantity style={{whiteSpace: 'nowrap'}}>{type}</LeftItemQuantity>
                            </Col>
                            <Col xs={4}>
                              <CenterHeaderQuantity>&nbsp;</CenterHeaderQuantity>
                            </Col>
                            <Col xs={4}>
                              <RightItemQuantity>- {formatCurrency(value)}</RightItemQuantity>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    )}
                    {orderDetails.shippingTaxDiscount !== 0 &&
                      <Row style={{ padding: '0.5rem 2rem' }}>
                        <Col xs={4}>
                          <LeftItemQuantity style={{whiteSpace: 'nowrap'}}>Taxa de entrega</LeftItemQuantity>
                        </Col>
                        <Col xs={4}>
                          <CenterHeaderQuantity>&nbsp;</CenterHeaderQuantity>
                        </Col>
                        <Col xs={4}>
                          <RightItemQuantity>{formatCurrency(orderDetails.shippingTaxDiscount)}</RightItemQuantity>
                        </Col>
                      </Row>
                    }
                    {orderDetails.reweighingDiscountValue !== 0 &&
                      <Row style={{ padding: '0.5rem 2rem' }}>
                        <Col xs={4}>
                          <LeftItemQuantity>Repesagem</LeftItemQuantity>
                        </Col>
                        <Col xs={4}>
                          <CenterHeaderQuantity>&nbsp;</CenterHeaderQuantity>
                        </Col>
                        <Col xs={4}>
                          <RightItemQuantity>{formatCurrency(orderDetails.reweighingDiscountValue)}</RightItemQuantity>
                        </Col>
                      </Row>
                    }
                  </ContainerCard>
                  <ContainerCard style={{ marginTop: '2rem' }}>
                    <CardTable.Header style={CardHeaderTotal}>
                      <ContainerBody>
                        <Row>
                          <Col xs={6}>
                            <Product>
                              <LeftItemQuantityTotal>Valor Final do Pedido</LeftItemQuantityTotal>
                            </Product>
                          </Col>
                          <Col xs={6}>
                            <RightItemQuantityTotal>{formatCurrency(getTotal())}</RightItemQuantityTotal>
                          </Col>
                        </Row>
                      </ContainerBody>
                    </CardTable.Header>
                  </ContainerCard>
                  <OpenChatBot backgroundColor={'#00f3ff'} />
                </MainContainer>
              </div>
              {showButton &&
                <ButtonDivision>
                  <InfoButton
                    style={{ margin: "-1rem 0 1rem 0" }}
                    disabled={loadingPage}
                    onClick={() => history.push(router)}
                  >
                    {loadingPage ? (
                      <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <div>{message}</div>
                    )}
                  </InfoButton>
                </ButtonDivision>
              }
              </>
              )}
            </Card>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
